export default __webpack_public_path__ + "static/media/Kunal.61fc6ded.jpg";